import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {PaginationArgs, PaginationPage} from '../models/pagination.args';
import {Observable} from 'rxjs';
import {ContactUsWebDtoModel} from '../models/contact.us.web.dto.model';

@Injectable({
    providedIn: 'root'
})
export class ContactUsService {

    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/contactUs`;
    }

    public findContactUsByPage(paginationArgs: PaginationArgs): Observable<PaginationPage<ContactUsWebDtoModel>> {
        return this.http.get<PaginationPage<ContactUsWebDtoModel>>(`${this.baseUrl}?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}`);
    }
}
